import React, { useState } from "react";
import { FaVirus } from "react-icons/fa";

const DEFAULT_NCD_DATA = {
  enrolled: { value: 41713601, percent: 64.87 },
  enrolledOver30: { value: 26709193, percent: 64.03 },
  cbacCompleted: { value: 24312461, percent: 91.03 },
  screened: { value: 20617912, percent: 84.8 },
  rescreened: { value: 8648191, percent: 41.95 },
  followUpCompleted: { value: 1327839 },
  followUpAdherence: { value: 353132 },
};

export default function NCDDataCard({ selectedDistrict = null, seed = null }) {
  const [open, setOpen] = useState(false);

  // Scale data for district view (20% of default)
  const data = selectedDistrict
    ? Object.fromEntries(
        Object.entries(DEFAULT_NCD_DATA).map(([key, val]) => [
          key,
          {
            value: Math.round(val.value * 0.2),
            percent: val.percent,
          },
        ])
      )
    : DEFAULT_NCD_DATA;

  // ------------------------------
  // ⭐ ADD COMPARISON LOGIC HERE ⭐
  // ------------------------------

  const current = data.enrolled.value;

  // Last month (dummy): 10% less than current
  const lastMonth = Math.round(current * 0.9);

  const diff = current - lastMonth;
  const percentChange = Math.round((diff / lastMonth) * 100);

  const isUp = diff > 0; // arrow direction only (color remains red)

  // ------------------------------

  return (
    <>
      {/* Small Card */}
      <button
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-3 px-3 py-2 rounded-lg shadow-sm bg-white border hover:shadow-md w-full"
      >
        <div className="w-10 h-10 flex items-center justify-center rounded-md bg-red-100">
          <FaVirus className="text-red-600 w-5 h-5" />
        </div>

        <div className="text-left">
          <div className="text-xs text-slate-600 font-medium">NCD Enrolled</div>

          <div className="text-lg font-semibold">
            {current.toLocaleString('en-IN')}
          </div>

          {/* ⭐ COMPARISON LINE (Same UI as Fully Immunized) ⭐ */}
          <div className="text-[11px] mt-0.5">
            <span className="text-red-600">
              {isUp ? "▼" : "▲"} {Math.abs(percentChange)}%
            </span>
            <span className="text-slate-500"> vs previous period</span>
          </div>
        </div>
      </button>

      {/* Offcanvas */}
      {open && (
        <div className="fixed inset-0 z-50 flex">
          <div className="absolute inset-0 bg-black/40" onClick={() => setOpen(false)} />

          <aside className="relative ml-auto w-full max-w-md h-full bg-white shadow-2xl overflow-auto">
            <div className="p-4 border-b flex items-center justify-between">
              <h3 className="text-lg font-semibold">NCD Data</h3>
              <button
                onClick={() => setOpen(false)}
                className="px-3 py-1 rounded bg-slate-100 text-sm"
              >
                Close
              </button>
            </div>

            <div className="p-4 space-y-4">
              {[
                { label: "Enrolled", data: data.enrolled },
                { label: "Enrolled Over 30", data: data.enrolledOver30 },
                { label: "CBAC Completed", data: data.cbacCompleted },
                { label: "Screened", data: data.screened },
                { label: "ReScreened", data: data.rescreened },
                { label: "Follow Up Completed", data: data.followUpCompleted },
                { label: "Follow Up Adherence", data: data.followUpAdherence },
              ].map((item) => (
                <div key={item.label}>
                  <div className="flex justify-between items-center mb-1">
                    <span className="text-sm font-medium">{item.label}</span>
                    <span className="text-sm font-semibold">
                      {item.data.value.toLocaleString('en-IN')}
                      {item.data.percent ? ` (${item.data.percent}%)` : ""}
                    </span>
                  </div>

                  {item.data.percent && (
                    <div className="w-full bg-slate-200 rounded-full h-2">
                      <div
                        className="bg-red-600 h-2 rounded-full"
                        style={{ width: `${item.data.percent}%` }}
                      ></div>
                    </div>
                  )}
                </div>
              ))}

              <div className="mt-2 text-xs text-slate-500">Source: HMIS-Apr24 to Mar 25</div>
            </div>
          </aside>
        </div>
      )}
    </>
  );
}
